import ArticleItemCover from '@/cmsComponents/ArticleItemCover';
import { PATH } from 'constants/path';
import Link from 'next/link';
import React from 'react';
import { IArticleSummary } from 'types/cms';

import Grid from '@material-ui/core/Grid';

import styles from './style.module.scss';

interface IProps {
  articles: Array<IArticleSummary>;
}

// The number of articles this component actually renders (1 cover + up to 4 in the list).
// Exported so callers building structured data for this section (e.g. the ItemList JSON-LD
// on the Articles index page) can cap their article list to what's really on the page.
export const FEATURED_ARTICLES_DISPLAY_LIMIT = 5;

export const FeaturedArticleSection: React.FC<IProps> = ({ articles }) => {
  const [first, ...rest] = articles.slice(0, FEATURED_ARTICLES_DISPLAY_LIMIT);
  return (
    <Grid container spacing={3} className={styles.container}>
      {first && (
        <Grid item md={7} xs={12}>
          <ArticleItemCover article={first} />
        </Grid>
      )}
      <Grid item md={5} xs={12}>
        <h2 className={styles.componentsTitle}>Recent stories</h2>
        <ul className={styles.list}>
          {rest.map(i => (
            <li key={i.id}>
              {i.article_category?.name && (
                <span className={styles.category}>{i.article_category?.name}</span>
              )}
              <Link
                prefetch={false}
                href={`${PATH.ARTICLES}/${i.slug}`}
                as={`${PATH.ARTICLES}/${i.slug}`}
                title={i.title}
              >
                {i.title}
              </Link>
            </li>
          ))}
        </ul>
      </Grid>
    </Grid>
  );
};
